import React from 'react';
import { Row, Col } from 'antd';
import { useParams } from 'react-router-dom';

import { useApplicationContext } from '@/context/v1/Application/context';
import { useGetCustomReportByName, useGetCustomReport } from '@/hooks';
import { JdsD92RouteParams } from './context/types';
import { LoadingSkeleton } from './LoadingSkeleton';
import { Text } from '@/components/Typography';
import { JdsD92Provider } from './context';
import { Report } from './Report';

const REPORT_NAME = 'jds_d92';

export function JdsD92() {
	const { file_id } = useParams<JdsD92RouteParams>();
	const { organization, company } = useApplicationContext();

	const {
		data: customReport,
		isFetching: isFetchingCustomReportByName,
		isError: errorGettingCustomReportByName
	} = useGetCustomReportByName({
		company_id: company?.id,
		report_name: REPORT_NAME,
		organization_id: organization?.id
	});

	const {
		data: jdsD92,
		isLoading,
		isError,
		isFetching
	} = useGetCustomReport({
		file_id,
		company_id: company?.id,
		custom_report_id: customReport.id,
		organization_id: organization?.id
	});

	if (isError || errorGettingCustomReportByName) {
		return <Text>Oops... Something went wrong!</Text>;
	}

	if (isLoading || isFetching || isFetchingCustomReportByName) {
		return <LoadingSkeleton />;
	}

	return (
		<Row>
			<Col xs={24}>
				<JdsD92Provider jdsD92={jdsD92} customReport={customReport}>
					<Report />
				</JdsD92Provider>
			</Col>
		</Row>
	);
}
